module.exports = __webpack_public_path__ + "img/heimweh_char_sheet_alex.e39146ad.png";